import { OrganizationState, OrganizationType } from '@/enums'

export class AccountOrganization {
  constructor(init: Partial<AccountOrganization> = {}) {
    this.id = init.id || 0
    this.shortName = init.shortName || ''
    this.name = init.name || ''
    this.type = init.type || OrganizationType.Coach
    this.state = init.state || OrganizationState.Offboarded
  }

  id: number
  shortName: string
  name: string
  type: OrganizationType
  state: OrganizationState
}
